/* istanbul ignore file */

// Wrap mark for some very old browsers that don't support it, but we don't really care
export function mark(name: string) {
	if (typeof performance.mark === 'function') {
		performance.mark('advert - ' + name);
	}
}
